import React, { useState, useRef, useEffect, useMemo } from "react";
import { useSpring, animated, easings } from "react-spring";
import { motion, AnimatePresence } from "framer-motion";
import secureLocalStorage from "react-secure-storage";
// import Logo from "../../Images/logo.png";

import {
    OpenAIOutlined,
    UserOutlined,
} from "@ant-design/icons";

import Logo from "../../Images/logo2.png";
import Lottie from 'react-lottie-player'
import { Loading } from "../../Components/Lottie/Loading";
import { Collapse } from "antd";
import Tooltip from '@mui/material/Tooltip';

// import { returnMockData, returnMockDataSource } from "../../Services/mockData";

import Probing from "../../Components/Probing/Probing";
import Sources from "../../Components/Sources/Sources";
import Pakages from "../../Components/Pakages/Pakages";
import PdmPacks from "../../Components/Pakages/PdmPacks";
import PdmChannels from "../../Components/Pakages/PdmChannels";
import RestartChat from "../../Components/RestartChat/RestartChat";
import UnderDevelopent from "../../Components/Pakages/UnderDevelopent";
import PdmSingles from "../../Components/Pakages/PdmSingles";
import LoadingDots from "../../Components/Lottie/LoadingDots";
import Regenerate from "../../Components/Regenerate/Regenerate";
import FeedbackPopUp from "../../Components/FeedbackPopUp/FeedbackPopUp";
import apiService from "../../Services/apiServices";
import SubcriberId from "../../Components/SubcriberIdFlow/SubcriberId";
import CustomerDetails from "../../Components/SubcriberIdFlow/CustomerDetails";
import Prechecks from "../../Components/SubcriberIdFlow/Prechecks";
import AskQuestion from "../../Components/SubcriberIdFlow/AskQuestion";
import Intent from "../../Components/SubcriberIdFlow/Intent";

import ProbingMultiIntent from "../../Components/Probing/ProbingMultiIntent";
import Pulse from "../../Components/Pakages/Pulse";
import BoilerSelections from "../../Components/SubcriberIdFlow/BoilerSelections";
import CreateWorkOrderTab from "../../Components/SubcriberIdFlow/CreateWorkOrderTab";
import MessageA3f from "../../Components/MessageCodes/MessageA3f";
import MessageA14c from "../../Components/MessageCodes/MessageA14c";
import MessageA1 from "../../Components/MessageCodes/MessageA1";
import MessageA9T from "../../Components/MessageCodes/MessageA9T";
import MessageA13 from "../../Components/MessageCodes/MessageA13";
import MessageA13s from "../../Components/MessageCodes/MessageA13s";
import MessageA26LLM from "../../Components/MessageCodes/MessageA26LLM";
import MessageA15 from "../../Components/MessageCodes/MessageA15";
import MessageA3b from "../../Components/MessageCodes/MessageA3b";
import MessageA23 from "../../Components/MessageCodes/MessageA23";
import MessageA3i from "../../Components/MessageCodes/MessageA3i";
import MessageA13t from "../../Components/MessageCodes/MessageA13t";
import MessageA26LLMf from "../../Components/MessageCodes/MessageA26LLMf";
import MessageA62 from "../../Components/MessageCodes/MessageA62";
import MessageA20 from "../../Components/MessageCodes/MessageA20";
import MessageA14s from "../../Components/MessageCodes/MessageA14s";
import R1FeedBack from "../../Components/FeedbackPopUp/R1FeedBack";
import MessageAF1 from "../../Components/MessageCodes/MessageAF1";
import POPRredirect from "../../Components/MessageCodes/POPRredirect";
import MessageA13ts from "../../Components/MessageCodes/MessageA13ts";
import Crousal from "../../CommonUtils/Crousal/Crousal";
import MessageA59 from "../../Components/MessageCodes/MessageA59";
import MessageA58 from "../../Components/MessageCodes/MessageA58";
import MessageA13packs from "../../Components/MessageCodes/MessageA13packs";
import MessageA61 from "../../Components/MessageCodes/MessageA61";
import MessageA63 from "../../Components/MessageCodes/MessageA63";
import LoadCxMsg from "../../Components/LoadCxMsg/LoadCxMsg";
import DateTimePicker from "../../CommonUtils/DatePicker/DateTimePicker";
import MessageA3intent from "../../Components/MessageCodes/MessageA3intent";
import MessageA3ud from "../../Components/MessageCodes/MessageA3ud";
import MessageA14input from "../../Components/MessageCodes/MessageA14input";
import A1Popup from '../../Components/MessageCodes/MessageA1Popup';
import MessageA14info from '../../Components/MessageCodes/MessageA14info';
import A1Invoice from '../../Components/MessageCodes/MessageA1invoice';
import MessageA1grey from "../../Components/MessageCodes/MessageA1grey";
import iconPlus from '../../Images/IconPlusPink.svg'
import iconMinus from '../../Images/IconMinusPink.svg'
import MessageA3Auto from "../../Components/MessageCodes/MessageA3Auto";
import MessageA3Refresh from "../../Components/MessageCodes/MessageA3Refresh";
import MessageA13ExplorePacks from "../../Components/MessageCodes/MessageA13ExplorePacks";
import MessageA13ExploreNonGenric from "../../Components/MessageCodes/MessageA13ExploreNonGenric";
import MessageA13ExploreGenric from "../../Components/MessageCodes/MessageA13ExploreGenric";
import MessageA3dealerdetail from "../../Components/MessageCodes/MessageA3dealerdetail";
import MessageA3Table from "../../Components/MessageCodes/MessageA3Table";
import RadioGroupField from "../../CommonUtils/RadioButton/RadioGroupField";
import MessageA13rechargeOptions from "../../Components/MessageCodes/MessageA13rechargeOptions";
import A3PackDetails from "../../Components/MessageCodes/A3PackDetails";
import SetupBox from "../../Components/MessageCodes/SetupBox";
import A3BillingDetails from "../../Components/MessageCodes/A3BillingDetails";
import MessageA1RequestTrack from "../../Components/MessageCodes/MessageA1RequestTrack";
import GenaiOneViewTable from "../../Components/MessageCodes/GenaiOneViewTable";
import ExplorePacks from '../../Components/ExplorePacks/ExplorePacks';
import A1MenuButtons from "../../Components/MessageCodes/A1MenuButton/A1MenuButtons";
import ACollapseTable from "../../Components/MessageCodes/ACollapseTable";
import AGENTASSISTPOPUP from "../../Components/MessageCodes/AGENTASSISTPOPUP";


const Conversation = (props) => {
    const { setShowMsgs,
        showMsgs,
        messages,
        updateMessage,
        setIsFeedbackPop,
        clearMessages,
        loading,
        showMaximumChat,
        scrollToBottom,
        isFeedbackPop,
        token,
        sessionId,
        startLogin,
        setIsThirtyMinPopUP,
        IsThirtyMinPopUP,
        setIsShowBot,
        setDisableInputBox,
        checkThumsDownFeedback,
        setCheckThumsDownFeedback,
        setIndexForPopUp,

        setisSubscriber,
        isSubscriber,
        addMessages,
        addMessagesPhase2,
        setIsShowMaximumChat,
    } = props


    const [showBotFlow, isSetBotFlow] = useState(false);
    const [toggleListIcon, setToggleListIcon] = useState(false)
    const [messageBoard, setMessageBoard] = useState(false);
    const [errors, setErrors] = useState({});
    const [processedMessages, setProcessedMessages] = useState(new Set());
    const [quckActionButton ,setQuickActionButton] = useState(null)
    const [showMenuButtons, setShowMenuButtons] = useState(false);

    const scrollToLastMessage = () => {
        setTimeout(() => {
            const conversationContainer = document.querySelector('.fullPageBotChatWrap');
            if (conversationContainer) {
                conversationContainer.scrollTop = conversationContainer.scrollHeight;
            }
        }, 300);
    };




    // const fadeInProps = useSpring({
    //     from: { opacity: Math.random() },
    //     to: { opacity: 1 },
    //     config: { duration: 1000, easing: easings.easeInOut },
    //     // Adjust duration and easing as needed
    // });
    const randomStart = useMemo(() => Math.random(), []);

    const fadeInProps = useSpring({
        from: { opacity: randomStart },
        to: { opacity: 1 },
        config: { duration: 1000, easing: easings.easeInOut },
    });


    const customerStyles = {
        from: { transform: 'translateX(100%)' },
        to: { transform: 'translateX(0%)' },
        config: { duration: 1000, easing: easings.easeInOut }
    };


    const handelThum = () => {
        setIsFeedbackPop(true)
    }

    useEffect(() => {
        if (!messages || messages.length === 0) return;

        messages.forEach((msg) => {
            if (!msg?.entries) return;

            let initialErrors = {};

            msg.entries.forEach((item, index) => {
                if (item?.uiCommand === "A13") {
                    initialErrors[`${item.uiCommand}-${index}`] = false;
                }
                if (item?.uiCommand === "A13s") {
                    initialErrors[`${item.uiCommand}-${index}`] = false;
                }
                if (item?.uiCommand === "A14c") {
                    initialErrors[`${item.uiCommand}-${index}`] = false;
                }
                if (item?.uiCommand === "A14s") {
                    initialErrors[`${item.uiCommand}-${index}`] = false;
                }
                if (item?.uiCommand === "A13ts") {
                    initialErrors[`${item.uiCommand}-${index}`] = false;
                }
                if (item?.uiCommand === "A22") {
                    initialErrors[`${item.uiCommand}-${index}`] = false;
                }
                if (item?.uiCommand === "A14input" || item?.uiCommand === "A14info") {
                    initialErrors[`${item.uiCommand}-${index}`] = false;
                }
                if (item?.uiCommand === "A3table") {
                    let data = {};

                    try {
                    data = typeof item?.text === "string" &&
                            (item.text.trim().startsWith("{") || item.text.trim().startsWith("["))
                        ? JSON.parse(item.text)
                        : item?.text;
                    } catch (e) {
                    data = item?.text;
                    }


                    if (data?.isRadioButton) {
                        initialErrors[`${item.uiCommand}-${index}`] = false;
                    }

                }
                if (item?.uiCommand === "A13r") {
                    initialErrors[`${item.uiCommand}-${index}`] = false;
                }
                if (item?.uiCommand === "A13ExplorePacks") {
                    initialErrors[`${item.uiCommand}-${index}`] = false;
                }
                // if (item?.uiCommand === "A13ExplorePacksNew") {
                //     initialErrors[`${item.uiCommand}-${index}`] = false;
                // }
                if (item?.uiCommand === "A3PackDetails" || item?.uiCommand === "A3PackDetails") {
                    let data = {};
                    try {
                        data = typeof item?.data === "string" ? JSON.parse(item.data) : item?.data;
                    } catch (e) {
                        data = item?.data;
                    }
                    
                    if (data?.isError === false) {
                       return
                    }else{
                        initialErrors[`${item.uiCommand}-${index}`] = false;
                    }
                }
                if (item?.uiCommand === "A13SetupBoxDetails") {
                    initialErrors[`${item.uiCommand}-${index}`] = false;
                }

            });
            // Check for A1break in the last 2 entries
            const lastTwo = msg?.entries?.slice(-4) || [];
            const hasA1Break = msg?.entries?.some((entry) => entry?.uiCommand === "A1break");

            if (hasA1Break) {
                // Merge with existing errors
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    ...initialErrors,
                }));
            } else {
                // Replace with fresh errors
                setErrors(initialErrors);
            }
        });
    }, [messages]);

    useEffect(()=>{
        if (messages.length > 0 && !loading) {
            const lastMsg = messages[messages.length - 1];
            const hasA62 = lastMsg?.entries?.some(item => item.uiCommand === "A62");
            
            if (hasA62) {
                setShowMenuButtons(false);
                return;
            }
            
            const menuItem = lastMsg?.entries?.find(item => item.uiCommand === "A1MenuButtons");
            
            if (menuItem && menuItem.data && menuItem.data !== "") {
                const parsedData = typeof menuItem.data === 'string' ? JSON.parse(menuItem.data) : menuItem.data;
                const staticButtons = parsedData?.staticButtonsV1 ? Object.values(parsedData.staticButtonsV1).flat() : [];
                const dynamicButtons = parsedData?.dynamicButtonsV1 ? Object.values(parsedData.dynamicButtonsV1).flat() : [];
                
                if (staticButtons.length > 0) {
                    const inputSessionId = sessionStorage.getItem('inputSessionId')
                    sessionStorage.setItem(inputSessionId, JSON.stringify(staticButtons));
                }
                
                const combinedButtons = [...staticButtons, ...dynamicButtons];
                
                if (combinedButtons.length === 0) {
                    setQuickActionButton(null);
                    setShowMenuButtons(false);
                    return;
                }
                
                const combinedData = { data: JSON.stringify(combinedButtons), uiCommand: "A1MenuButtons" };
                
                setQuickActionButton(combinedData);
                setShowMenuButtons(true);
            } else {
                const savedStatic = sessionStorage.getItem(sessionStorage.getItem('inputSessionId'));
                if (savedStatic) {
                    setShowMenuButtons(true);
                    if (!quckActionButton || quckActionButton.data !== savedStatic) {
                        const staticData = { data: savedStatic, uiCommand: "A1MenuButtons" };
                        setQuickActionButton(staticData);
                    }
                } else {
                    setQuickActionButton(null);
                    setShowMenuButtons(false);
                }
            }
        }
    },[messages, loading])




    //Load Message
    const showMsgWindow = () => {

        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    height: "100%",
                    flexDirection: "column",
                }}
            >
                <img style={{ width: messages?.length === 0 && showMaximumChat ? '574px' : "250px" }} alt="botLogo" src={Logo}></img>
                <div className={messages?.length === 0 && showMaximumChat ? 'helper-no-msg' : "helper-msg"}> How can I Help you today?</div>
            </div>

        )
    }

    //load end chat 
    const endChat = () => {
        return (
            <div style={{ width: showMaximumChat && '30%' }} className="restart-pop-up">
                <p className="idle-msg-container-content">
                    <span style={{ fontWeight: "bold", fontFamily: 'sans-serif' }}>
                        Since it's been a while and there is no revert from you
                        yet, we'll have to close the chat window. But drop by
                        again anytime in case you start missing us. We loved
                        hearing from you. Have a great day!
                    </span>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        <button
                            onClick={() => {
                                setIsThirtyMinPopUP(false)
                                clearMessages()
                                // apiService.loginForRefresh('6')
                                // startLogin()
                                setShowMsgs(false)
                                setIsShowBot(false)
                                setDisableInputBox(false)
                            }}
                            style={{
                                background: "#D02F92",
                                border: "1px solid white",
                                borderRadius: "5px",
                                color: "white",
                                width: "6rem",
                                fontSize: "small",
                                cursor: 'pointer',
                                marginTop: '12px',
                                height: '30px'
                            }}
                        >
                            End Chat
                        </button>
                    </div>
                </p>
            </div>
        )
    }


    const loadLottie = () => {
        return (
            <div style={{ width: '10rem', height: '10rem', margin: 'auto', marginTop: '3rem' }}> <Lottie
                loop
                animationData={Loading}
                play
                style={{ width: 150, height: 150 }}
            /></div>
        )
    }


    const loadProbingSection = (msg, index) => {
        return (
            <div
                className="server-probe-response-body"
                style={fadeInProps}
            >
                {msg?.messageType === "Pulse_multiResponse" ? (
                    <ProbingMultiIntent
                        setIsFeedbackPop={setIsFeedbackPop}
                        data={msg}
                        scrollToBottom={scrollToBottom}
                        setMessageBoard={setMessageBoard}
                        messageBoard={messageBoard}
                        showMaximumChat={showMaximumChat}
                    />
                ) : (
                    <Probing
                        setIsFeedbackPop={setIsFeedbackPop}
                        data={msg}
                        scrollToBottom={scrollToBottom}
                        setMessageBoard={setMessageBoard}
                        messageBoard={messageBoard}
                        showMaximumChat={showMaximumChat}
                    />
                )}
                {/* //Regenerate */}
                {/* <Regenerate index={index} msg={msg} messages={messages} fadeInProps={fadeInProps} updateMessage={updateMessage} showMaximumChat={showMaximumChat} setIsFeedbackPop={setIsFeedbackPop} token={token} sessionId={sessionId} checkThumsDownFeedback={checkThumsDownFeedback} /> */}
            </div>
        )
    }



    const loadChatMessages = (msg, index) => {

        if (msg?.messageType === "preChecks") {
            return (
                <Prechecks
                    showMaximumChat={showMaximumChat}
                    setisSubscriber={setisSubscriber}
                    isSubscriber={isSubscriber}
                    addMessages={addMessages}

                    scrollToBottom={scrollToBottom}
                />

            )
        }



        if (msg?.messagetype === "Troubleshooting") {

            return (
                <MessageA9T
                    showMaximumChat={showMaximumChat}
                    setisSubscriber={setisSubscriber}
                    isSubscriber={isSubscriber}
                    addMessages={addMessages}

                    scrollToBottom={scrollToBottom}
                    data={msg}
                    setIsShowMaximumChat={setIsShowMaximumChat}
                />

            )
        }


        if (msg?.messageType === "technical" || msg?.messageType === "package" || msg?.messageType === "billing") {

            return (
                <Intent
                    data={msg}
                    showMaximumChat={showMaximumChat}
                    setisSubscriber={setisSubscriber}
                    isSubscriber={isSubscriber}
                    addMessages={addMessages}
                    index={index}
                    setErrors={setErrors}
                />

            )
        }




        if (msg?.isFailed || msg?.messageType === "UnderDevelopment") {
            return (
                <UnderDevelopent
                    data={msg}
                    showMaximumChat={showMaximumChat}
                    loading={loading}
                    setIsFeedbackPop={setIsFeedbackPop}
                    updateMessage={updateMessage}
                    index={index}
                    messages={messages}
                    sessionId={sessionId}
                    checkThumsDownFeedback={checkThumsDownFeedback}
                />

            )
        }

        if (msg?.messageType === "Failure_message") {
            return (
                <UnderDevelopent
                    data={msg}
                    showMaximumChat={showMaximumChat}
                    loading={loading}
                    setIsFeedbackPop={setIsFeedbackPop}
                    updateMessage={updateMessage}
                    index={index}
                    messages={messages}
                    sessionId={sessionId}
                    checkThumsDownFeedback={checkThumsDownFeedback}
                />

            )
        }



        if (msg?.messageType === "pdm_packs") {
            return (
                <PdmPacks
                    data={msg}
                    showMaximumChat={showMaximumChat}
                    loading={loading}
                    setIsFeedbackPop={setIsFeedbackPop}
                    updateMessage={updateMessage}
                    index={index}
                    messages={messages}
                    sessionId={sessionId}
                    checkThumsDownFeedback={checkThumsDownFeedback}
                />
            );
        }
        if (msg?.messageType === "pdm_channel") {
            return (
                <PdmChannels
                    data={msg}
                    showMaximumChat={showMaximumChat}
                    loading={loading}
                    setIsFeedbackPop={setIsFeedbackPop}
                    updateMessage={updateMessage}
                    index={index}
                    messages={messages}
                    sessionId={sessionId}
                    checkThumsDownFeedback={checkThumsDownFeedback}
                />
            );
        }
        // if (msg?.messageType === "UnderDevelopment") {
        //   return (
        //     <UnderDevelopent
        //       data={msg}
        //       showMaximumChat={showMaximumChat}
        //       setIsFeedbackPop={setIsFeedbackPop}
        //       loading={loading}
        //       messages={messages}
        //       sessionId={sessionId}
        //       updateMessage={updateMessage}
        //     />
        //   );
        // }
        if (msg?.messageType === "pdm_single") {
            return (
                <PdmSingles
                    data={msg}
                    showMaximumChat={showMaximumChat}
                    loading={loading}
                    setIsFeedbackPop={setIsFeedbackPop}
                    updateMessage={updateMessage}
                    index={index}
                    messages={messages}
                    sessionId={sessionId}
                    checkThumsDownFeedback={checkThumsDownFeedback}
                />
            );
        }

        if (msg?.messageType === "Pulse_3" || msg?.messageType === "Pulse_2") {
            return (
                <Pulse
                    data={msg}
                    showMaximumChat={showMaximumChat}
                    loading={loading}
                    setIsFeedbackPop={setIsFeedbackPop}
                    updateMessage={updateMessage}
                    index={index}
                    messages={messages}
                    sessionId={sessionId}
                    checkThumsDownFeedback={checkThumsDownFeedback}
                />
            );
        }

        if (msg?.messageType === "Pulse_multiResponse") {
            return <>{loadProbingSection(msg, index)}</>
        }

        return

    }

    const [showAllButtons, setShowAllButtons] = useState(false);

    const loadMsgPhaseTwo = (msg, index) => {
        const array = msg?.entries;
        let isAfterA3f = false;

        if (msg?.isFailed) {
            return (
                <UnderDevelopent
                    data={msg}
                    showMaximumChat={showMaximumChat}
                    loading={loading}
                    setIsFeedbackPop={setIsFeedbackPop}
                    updateMessage={updateMessage}
                    index={index}
                    messages={messages}
                    sessionId={sessionId}
                    checkThumsDownFeedback={checkThumsDownFeedback}
                />

            )
        }
        const allowed = ["A1", "A15", "A1grey"];

        const getConsecutiveAllowedItems = (array) => {
            let start = -1;

            for (let i = 0; i < array.length; i++) {
                if (allowed.includes(array[i].uiCommand)) {
                    if (start === -1) start = i;
                } else if (start !== -1) {
                    const group = array.slice(start, i);
                    return group.length > 4 ? group : []; //  Only return if > 4
                }
            }

            // Handle case where consecutive group is at the end
            if (start !== -1) {
                const group = array.slice(start);
                return group.length > 4 ? group : [];
            }

            return [];
        };

        const a1GroupItems = getConsecutiveAllowedItems(array);



        return (
            <>
                {array?.map((item, index) => {
                    // Skip A1,A15,A1grey group here, we'll render them below
                    // if (
                    //     item?.uiCommand === "A1" ||
                    //     item?.uiCommand === "A15" ||
                    //     item?.uiCommand === "A1grey" 
                    // ) {
                    //     return null;
                    // }

                    return (
                        <React.Fragment key={item?.id || index}>
                            {/* Your original conditional components */}
                            {item?.uiCommand === "A3" &&
                                loadChatMessages(
                                    (() => {
                                        try {
                                            return JSON.parse(item?.text);
                                        } catch (e) {
                                            return item?.text;
                                        }
                                    })(),
                                    index
                                )}

                            {item.uiCommand === "A1e" &&
                                secureLocalStorage.setItem("specialCode", item.code)
                            }
                            {item?.uiCommand === "A13ts" && (
                                <Crousal item={item} addMessagesPhase2={addMessagesPhase2} setisSubscriber={setisSubscriber} addMessages={addMessages} setErrors={setErrors} errors={errors} index={`${item?.uiCommand}-${index}`} showMaximumChat={showMaximumChat}  {...props} />
                            )}
                            {item?.uiCommand === "A59" && (
                                <MessageA59 item={item} addMessagesPhase2={addMessagesPhase2} setisSubscriber={setisSubscriber} addMessages={addMessages} setErrors={setErrors} errors={errors} index={`${item?.uiCommand}-${index}`} showMaximumChat={showMaximumChat}  {...props} />
                            )}
                            {item?.uiCommand === "A58" && (
                                <MessageA58 item={item} addMessagesPhase2={addMessagesPhase2} setisSubscriber={setisSubscriber} addMessages={addMessages} setErrors={setErrors} errors={errors} index={`${item?.uiCommand}-${index}`} {...props} />
                            )}
                            {item?.uiCommand === "A61" && (
                                <MessageA61 item={item} addMessagesPhase2={addMessagesPhase2} setisSubscriber={setisSubscriber} addMessages={addMessages} setErrors={setErrors} errors={errors} index={`${item?.uiCommand}-${index}`} showMaximumChat={showMaximumChat}  {...props} />
                            )}
                            {item?.uiCommand === "A63" && (
                                <MessageA63 item={item} addMessagesPhase2={addMessagesPhase2} setisSubscriber={setisSubscriber} addMessages={addMessages} setErrors={setErrors} errors={errors} index={`${item?.uiCommand}-${index}`} confirmCode={item?.code} showMaximumChat={showMaximumChat} {...props} />
                            )}


                            {item?.uiCommand === "A13packs" && (

                                <MessageA13packs item={item} addMessagesPhase2={addMessagesPhase2} setisSubscriber={setisSubscriber} addMessages={addMessages} setErrors={setErrors} errors={errors} index={`${item?.uiCommand}-${index}`} {...props} />
                            )}


                            {item?.uiCommand === "A3f" && (() => {
                                isAfterA3f = true;
                                return <MessageA3f item={item} />;
                            })()}

                            {item?.uiCommand === "A3b" && (() => {
                                return <MessageA3b item={item} />;
                            })()}

                            {item?.uiCommand === "A3BR" && (() => {
                                return <MessageA3b item={item} />;
                            })()}

                            {item?.uiCommand === "A14c" && (
                                <MessageA14c item={item} setErrors={setErrors} index ={`${item?.uiCommand}-${index}`} errors={errors} addMessages={addMessages} />
                              
                            )}
                            {item?.uiCommand === "GenaiOneViewTable" && (
                                <GenaiOneViewTable item={item} setErrors={setErrors} addMessages={addMessages}  index ={`${item?.uiCommand}-${index}`} setIsShowMaximumChat={setIsShowMaximumChat} showMaximumChat={showMaximumChat}  />
                              
                            )}
                            {item?.uiCommand === "A3BillingDetails" && (
                                <A3BillingDetails item={item} setErrors={setErrors} addMessages={addMessages} showMaximumChat={showMaximumChat} setIsShowMaximumChat={setIsShowMaximumChat} index={`${item?.uiCommand}-${index}`} />
                            )}
                            {item?.uiCommand === "A13SetupBoxDetails" && (
                                <SetupBox item={item} setErrors={setErrors} index={`${item?.uiCommand}-${index}`} addMessages={addMessages} showMaximumChat={showMaximumChat} setIsShowMaximumChat={setIsShowMaximumChat} />
                            )}

                            {item?.uiCommand === "A3PackDetails" && (
                                <A3PackDetails item={item} setErrors={setErrors} index={`${item?.uiCommand}-${index}`} addMessages={addMessages} errors={errors} showMaximumChat={showMaximumChat} setIsShowMaximumChat={setIsShowMaximumChat} />
                            )}
                            {item.uiCommand === "A1RequestTrack" && (
                                <MessageA1RequestTrack item={item} setErrors={setErrors} index={`${item?.uiCommand}-${index}`} addMessages={addMessages} errors={errors} showMaximumChat={showMaximumChat} setIsShowMaximumChat={setIsShowMaximumChat} />
                            )}
                            {/* {item?.uiCommand === "A3PackDetails" && (
                                <A3PackDetails   item={item} setErrors={setErrors} index ={`${item?.uiCommand}-${index}`} />
                            )} */}
                            {item?.uiCommand === "A13ExplorePacks" && (
                                <MessageA13ExplorePacks item={item} setErrors={setErrors} index={`${item?.uiCommand}-${index}`} addMessages={addMessages} errors={errors} />
                            )}
                            {item?.uiCommand === "A13ExploreNonGenric" && (
                                <MessageA13ExploreNonGenric item={item} setErrors={setErrors} index={`${item?.uiCommand}-${index}`} addMessages={addMessages} showMaximumChat={showMaximumChat} />
                            )}
                            {item?.uiCommand === "A13ExploreGenric" && (
                                <MessageA13ExploreGenric item={item} setErrors={setErrors} index={`${item?.uiCommand}-${index}`} addMessages={addMessages} showMaximumChat={showMaximumChat} />
                            )}
                            {item?.uiCommand === "A13ExplorePacksNew" && (() => {
                                if(item?.text === ""){
                                    return
                                }
                                const dataArray = item?.text ? JSON.parse(item?.text) : {};
                                
                                return (
                                    <>
                                        {dataArray.map((payload, idx) => (
                                            <ExplorePacks
                                                key={`${item?.uiCommand}-${index}-${idx}`}
                                                header={payload.header}
                                                packDetails={payload}
                                                sessionId={sessionId}
                                                errors={errors}
                                                setErrors={setErrors}
                                                index={`${item?.uiCommand}-${index}-${idx}`}
                                                showMaximumChat={showMaximumChat}
                                                setIsShowMaximumChat={setIsShowMaximumChat}
                                            />
                                        ))}
                                    </>
                                );
                            })()}
                            {item?.uiCommand === "A3ud" && (
                                <MessageA3ud item={item} setErrors={setErrors} index={`${item?.uiCommand}-${index}`} showMaximumChat={showMaximumChat} data={item?.text} />
                            )}
                            {item?.uiCommand === "A22" && (
                                <DateTimePicker item={item} setErrors={setErrors} errors={errors} index={`${item?.uiCommand}-${index}`} addMessages={addMessages} />
                            )}
                            {item?.uiCommand === "A3intent" && (
                                <MessageA3intent item={item} setErrors={setErrors} errors={errors} index={`${item?.uiCommand}-${index}`} showMaximumChat={showMaximumChat} addMessages={addMessages} />
                            )}
                            {item?.uiCommand === "A1Invoice" && (
                                <A1Invoice item={item} setErrors={setErrors} errors={errors} index={`${item?.uiCommand}-${index}`} showMaximumChat={showMaximumChat} data={item?.data} />
                            )}
                            {item?.uiCommand === "A1Popup" && <A1Popup item={item} />}
                            {item?.uiCommand === "A14info" && <MessageA14info item={item} setErrors={setErrors} index={`${item?.uiCommand}-${index}`} />}
                            {item?.uiCommand === "A14s" && <MessageA14s item={item} setErrors={setErrors} index={`${item?.uiCommand}-${index}`} />}
                            {item?.uiCommand === "POPRredirect" && <POPRredirect {...props} item={item} addMessagesPhase2={addMessagesPhase2} setisSubscriber={setisSubscriber} addMessages={addMessages} array={array} errors={errors} index={`${item?.uiCommand}-${index}`} />}
                            {item?.uiCommand === "A26LLM" && (
                                <MessageA26LLM
                                    array={array}
                                    item={(() => {
                                        try {
                                            return JSON.parse(item?.text);
                                        } catch (e) {
                                            return item?.text;
                                        }
                                    })()}
                                    addMessagesPhase2={addMessagesPhase2}
                                    setisSubscriber={setisSubscriber}
                                    addMessages={addMessages}
                                    scrollToBottom={scrollToBottom}
                                />
                            )}
                            {item?.uiCommand === "A26LLMf" && (
                                <MessageA26LLMf
                                    array={array}
                                    item={(() => {
                                        try {
                                            return JSON.parse(item?.text);
                                        } catch (e) {
                                            return item?.text;
                                        }
                                    })()}
                                    addMessagesPhase2={addMessagesPhase2}
                                    setisSubscriber={setisSubscriber}
                                    addMessages={addMessages}
                                    scrollToBottom={scrollToBottom}
                                />
                            )}

                            {item?.uiCommand === "A3i" && (
                                <MessageA3i
                                    array={array}
                                    item={item}
                                    addMessagesPhase2={addMessagesPhase2}
                                    setisSubscriber={setisSubscriber}
                                    addMessages={addMessages}
                                    scrollToBottom={scrollToBottom}
                                />
                            )}


                            {/* Regular rendering of A1 without inline condition */}
                            {/* {item?.uiCommand === "A1" && !isAfterA3f && (
                            <MessageA1
                                item={item}
                                addMessagesPhase2={addMessagesPhase2}
                                setisSubscriber={setisSubscriber}
                                addMessages={addMessages}
                            />
                            )} */}

                            {item?.uiCommand === "A13" && (
                                <MessageA13 item={item} addMessagesPhase2={addMessagesPhase2} setisSubscriber={setisSubscriber} addMessages={addMessages} setErrors={setErrors} errors={errors} index={`${item?.uiCommand}-${index}`} />
                            )}
                            {item?.uiCommand === "A13r" && (
                                <RadioGroupField item={item} addMessagesPhase2={addMessagesPhase2} setisSubscriber={setisSubscriber} addMessages={addMessages} setErrors={setErrors} errors={errors} index={`${item?.uiCommand}-${index}`} />
                            )}
                            {item?.uiCommand === "A3dealerdetail" && (
                                <MessageA3dealerdetail item={item} addMessagesPhase2={addMessagesPhase2} setisSubscriber={setisSubscriber} addMessages={addMessages} setErrors={setErrors} errors={errors} index={`${item?.uiCommand}-${index}`} />
                            )}
                            {item?.uiCommand === "A3table" && (
                                <MessageA3Table item={item} addMessagesPhase2={addMessagesPhase2} setisSubscriber={setisSubscriber} showMaximumChat={showMaximumChat} addMessages={addMessages} setErrors={setErrors} errors={errors} index={`${item?.uiCommand}-${index}`} />
                            )}
                            {item?.uiCommand === "A13s" && (
                                <MessageA13s item={item} addMessages={addMessages} setisSubscriber={setisSubscriber} showMaximumChat={showMaximumChat} setErrors={setErrors} index={`${item?.uiCommand}-${index}`} />
                            )}
                            {item?.uiCommand === "A13t" && (
                                <MessageA13t item={item} addMessages={addMessages} setisSubscriber={setisSubscriber} showMaximumChat={showMaximumChat} />
                            )}
                            {item?.uiCommand === "A62" && (
                                <MessageA62 item={item} addMessages={addMessages} setisSubscriber={setisSubscriber} showMaximumChat={showMaximumChat} />
                            )}
                            {item?.uiCommand === "A20" && (
                                <MessageA20 item={item} addMessages={addMessages} setisSubscriber={setisSubscriber} showMaximumChat={showMaximumChat} setIsShowMaximumChat={setIsShowMaximumChat} />
                            )}
                            {item?.uiCommand === "A14input" && (
                                <MessageA14input item={item} addMessages={addMessages} setisSubscriber={setisSubscriber} showMaximumChat={showMaximumChat} setIsShowMaximumChat={setIsShowMaximumChat} setErrors={setErrors} index={`${item?.uiCommand}-${index}`} />
                            )}

                            {item?.uiCommand === "A3Auto" && (
                                <MessageA3Auto item={item} addMessages={addMessages} setisSubscriber={setisSubscriber} showMaximumChat={showMaximumChat} setIsShowMaximumChat={setIsShowMaximumChat} setErrors={setErrors} index={`${item?.uiCommand}-${index}`} />
                            )}
                            {item?.uiCommand === "A3Refresh" && (
                                <MessageA3Refresh item={item} addMessages={addMessages} setisSubscriber={setisSubscriber} showMaximumChat={showMaximumChat} setIsShowMaximumChat={setIsShowMaximumChat} setErrors={setErrors} index={`${item?.uiCommand}-${index}`} />
                            )}

                            {item?.uiCommand === "A13rechargeOptions" && (
                                <MessageA13rechargeOptions item={item} addMessages={addMessages} setisSubscriber={setisSubscriber} showMaximumChat={showMaximumChat} setIsShowMaximumChat={setIsShowMaximumChat} setErrors={setErrors} index={`${item?.uiCommand}-${index}`} />
                            )}
                            

                          

                            {item?.uiCommand === "ACollapseTable" && (
                                <ACollapseTable item={item} addMessages={addMessages} setisSubscriber={setisSubscriber} showMaximumChat={showMaximumChat} setIsShowMaximumChat={setIsShowMaximumChat} setErrors={setErrors} index={`${item?.uiCommand}-${index}`} />
                            )}

                            {item?.uiCommand === "AGENTASSISTPOPUP" && (
                                <AGENTASSISTPOPUP item={item} addMessages={addMessages} setisSubscriber={setisSubscriber} showMaximumChat={showMaximumChat} setIsShowMaximumChat={setIsShowMaximumChat} setErrors={setErrors} index={`${item?.uiCommand}-${index}`} />
                            )}

                            {item?.uiCommand === "AF1" && (props?.setSaveFeedbackData(item), (
                                <MessageAF1
                                    item={item}
                                    addMessages={addMessages}
                                    setisSubscriber={setisSubscriber}
                                    showMaximumChat={showMaximumChat}
                                    setIsShowMaximumChat={setIsShowMaximumChat}
                                    array={array}
                                    setIsFeedbackPop={setIsFeedbackPop}
                                    checkThumsDownFeedback={checkThumsDownFeedback}
                                    showRegenerate={item?.isFailed}
                                    updateMessage={updateMessage}
                                    {...props}
                                />
                            ))}


                            {item?.uiCommand === "A23" && (
                                <MessageA23
                                    item={item}
                                    addMessagesPhase2={addMessagesPhase2}
                                    setisSubscriber={setisSubscriber}
                                    addMessages={addMessages}
                                />
                            )}
                            {item?.uiCommand === "A9T" && (<MessageA9T
                                showMaximumChat={showMaximumChat}
                                setisSubscriber={setisSubscriber}
                                isSubscriber={isSubscriber}
                                addMessages={addMessages}
                                scrollToBottom={scrollToBottom}
                                data={msg}
                                setIsShowMaximumChat={setIsShowMaximumChat}
                            />)}
                            {(item?.uiCommand === "A1" || item?.uiCommand === "A15" || item?.uiCommand === 'A1grey') &&
                                (a1GroupItems?.length === 0) && (
                                    <div style={{ display: "inline-block", overflow: 'hidden' }}>
                                        {item?.uiCommand === "A15" && (
                                            <MessageA15
                                                item={item}
                                                addMessagesPhase2={addMessagesPhase2}
                                                setisSubscriber={setisSubscriber}
                                                addMessages={addMessages}
                                                array={array}
                                                errors={errors}
                                                setErrors={setErrors}
                                                index={`${item?.uiCommand}-${index}`}
                                                showMaximumChat={showMaximumChat}
                                                messageId={array[index]?.id || index}
                                                setProcessedMessages={setProcessedMessages}
                                            />
                                        )}
                                        {item?.uiCommand === "A1" && (
                                            <MessageA1
                                                item={item}
                                                addMessagesPhase2={addMessagesPhase2}
                                                setisSubscriber={setisSubscriber}
                                                addMessages={addMessages}
                                            />
                                        )}
                                        {item?.uiCommand === "A1grey" && (
                                            <MessageA1grey
                                                item={item}
                                                addMessagesPhase2={addMessagesPhase2}
                                                setisSubscriber={setisSubscriber}
                                                addMessages={addMessages}
                                            />
                                        )}
                                    </div>
                                )}

                        </React.Fragment>
                    );
                })}

                {/* Render A1, A15, A1grey as group */}
                {a1GroupItems?.length > 0 && (
                    <div className={`a1-animated-extra-buttons action-tab ${showAllButtons ? 'show' : ''}`}>
                        {(showAllButtons ? a1GroupItems : a1GroupItems.slice(0, 4)).map((item, i) => {
                            const isExtraButton = showAllButtons && i >= 4;
                            return (
                                <div
                                    key={item?.id || `a1group-${i}`}
                                    className={isExtraButton ? "a1-animate-button" : ""}
                                    style={isExtraButton ? { "--i": i - 4 } : {}}
                                >
                                    {item?.uiCommand === "A15" && (
                                        <MessageA15
                                            item={item}
                                            addMessagesPhase2={addMessagesPhase2}
                                            setisSubscriber={setisSubscriber}
                                            addMessages={addMessages}
                                            array={array}
                                            errors={errors}
                                            setErrors={setErrors}
                                            index={`${item?.uiCommand}-${index}-${i}`}
                                            showMaximumChat={showMaximumChat}
                                            messageId={array[index]?.id || index}
                                            setProcessedMessages={setProcessedMessages}
                                        />
                                    )}
                                    {item?.uiCommand === "A1" && (
                                        <MessageA1
                                            item={item}
                                            addMessagesPhase2={addMessagesPhase2}
                                            setisSubscriber={setisSubscriber}
                                            addMessages={addMessages}
                                        />
                                    )}

                                    {item?.uiCommand === "A1grey" && (
                                        <MessageA1grey
                                            item={item}
                                            addMessagesPhase2={addMessagesPhase2}
                                            setisSubscriber={setisSubscriber}
                                            addMessages={addMessages}
                                        />
                                    )}
                                </div>
                            );
                        })}

                        {/* Show More / Show Less Toggle */}
                        {a1GroupItems?.length > 4 && (
                            <Tooltip title={showAllButtons ? 'Show Less' : 'Show More'} enterDelay={0} arrow>
                                <button
                                    onClick={() => setShowAllButtons((prev) => !prev)}
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        cursor: 'pointer',
                                        padding: 0,
                                        // marginTop: '8px',
                                    }}
                                >
                                    <img
                                        src={showAllButtons ? iconMinus : iconPlus}
                                        alt={showAllButtons ? 'Show Less' : 'Show More'}
                                        style={{ width: '30px', height: '30px' }}
                                    />
                                </button>
                            </Tooltip>
                        )}
                    </div>
                )}



            </>
        );
    };

    const checkA1MenuButtons = (msg) =>{

          const array = msg?.entries;

        const menuItem = array?.find(
        item => item.uiCommand === "A1MenuButtons"
        );
        if(menuItem){
            return menuItem
        }else{
            return false
        }
    }





    //main UI---------------------------------------------------
    return (

        <>
            {!showMsgs ? (
                IsThirtyMinPopUP ? endChat() : showMsgWindow()
            ) : (
                <>
                <animated.div style={fadeInProps}>
                    {messages?.length > 0 ?
                        (
                            <div
                                className="conversationContainer"
                                style={{
                                    width: showMaximumChat ? "100%" : "95%"
                                }}
                            >

                                {messages.map((msg, index) => (
                                    <animated.div className="oneConversation" style={fadeInProps}>
                                        <div
                                            className="oneConversation-left"
                                            style={{ width: !showMaximumChat ? "100%" : "90%", alignItems: msg?.type === 'BoilerSelect' && 'center' }}
                                        >
                                            {msg?.type === "CUSTOMER" &&   <LoadCxMsg msg={msg} showMaximumChat={showMaximumChat} customerStyles={customerStyles}/>          }
                                            {msg?.type === 'SERVER' &&
                                                <div
                                                    className="oneConversation-left-text-server"
                                                    style={{ fadeInProps, marginTop: msg?.entries?.some((el) => el?.uiCommand === "A1break") && '12px' }}
                                                >
                                                    {/* <OpenAIOutlined className="bot-reply-icon" /> */}
                                                    {!msg?.entries?.some((el) => el?.uiCommand === "A1break") && <img
                                                        className="bot-reply-icon"
                                                        style={{ width: '30px', height: '30px' }}
                                                        alt="src"
                                                        src={'data:image/png;base64,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'}
                                                    ></img>}
                                                    <div
                                                        className={
                                                            index === messages?.length - 1 && loading
                                                                ? "oneConversation-left-text-server-content-loading"
                                                                : "oneConversation-left-text-server-content"
                                                        }
                                                        style={{ fadeInProps, padding: showMaximumChat && "1%", marginLeft: msg?.entries?.some((el) => el?.uiCommand === "A1break") && '36px', width: msg?.entries?.some((el) => el?.uiCommand === "A3PackDetails" || el?.uiCommand === "A13ExplorePacksNew") && showMaximumChat && "98%" }}
                                                    >
                                                        <AnimatePresence mode="wait">
                                                            {index === messages?.length - 1 && loading ? (
                                                                <motion.div
                                                                    key="loading"
                                                                    initial={{ opacity: 0.6, scale: 0.98 }}
                                                                    animate={{ opacity: 1, scale: 1 }}
                                                                    exit={{ opacity: 0, scale: 0.98 }} // 🔹 Smooth fade-out for loader
                                                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                                                    justifyContent="center"
                                                                >
                                                                    <LoadingDots />
                                                                </motion.div>

                                                            ) : (
                                                                <motion.div
                                                                    key="message"
                                                                    initial={{ opacity: 0, scale: 1.02 }}
                                                                    animate={{ opacity: 1, scale: 1 }}
                                                                    exit={{ opacity: 0, scale: 0.98 }} // 🔹 Smooth fade-in for message
                                                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                                                >
                                                                    {loadMsgPhaseTwo(msg, index)}
                                                                </motion.div>
                                                            )}
                                                        </AnimatePresence>
                                                    </div>

                                                    {!msg?.entries?.some((el) => el?.uiCommand === "A1break") && <div
                                                        className="customer-time"
                                                        style={fadeInProps}
                                                    >
                                                        {msg?.time}
                                                    </div>}
                                                    {setIndexForPopUp(index)}
                                                    {props?.showR1FeedbackPop?.isActive && index === messages?.length - 1 && (
                                                        <R1FeedBack
                                                            {...props}
                                                            data={props?.saveFeedbackData}
                                                            className={props?.showR1FeedbackPop?.isActive ? "fade-in" : "fade-out"}
                                                        />
                                                    )}



                                                    {msg.type !== "CUSTOMER" && showMaximumChat && !messageBoard && !loading && index === messages.length - 1 && (
                                                        <Sources msg={msg} showMaximumChat={showMaximumChat} clearMessages={clearMessages} setShowMsgs={setShowMsgs} />
                                                    )}

                                                    {!showMaximumChat && isFeedbackPop && index === messages?.length - 1 && <FeedbackPopUp setIsFeedbackPop={setIsFeedbackPop} showMaximumChat={showMaximumChat} sessionId={sessionId} setCheckThumsDownFeedback={setCheckThumsDownFeedback} messages={messages} index={index} checkThumsDownFeedback={checkThumsDownFeedback} />}

                                                    {/* {index === messages.length - 1 && !isFeedbackPop && !loading && (
                                                        <RestartChat showMaximumChat={showMaximumChat} clearMessages={clearMessages} setShowMsgs={setShowMsgs} startLogin={startLogin} setCheckThumsDownFeedback={setCheckThumsDownFeedback} createOrderRequest={msg?.messageType === "technical" && true} index={index} flow={props.flow} item={msg?.entries} {...props} />
                                                    )} */}
                                                 
                                                 <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "12px",
                                                        marginTop: "8px",
                                                        flexWrap: "wrap",
                                                    }}
                                                    >
                                              
                                                    {index === messages.length - 1 && !isFeedbackPop && !loading && (
                                                        <RestartChat
                                                        showMaximumChat={showMaximumChat}
                                                        clearMessages={clearMessages}
                                                        setShowMsgs={setShowMsgs}
                                                        startLogin={startLogin}
                                                        setCheckThumsDownFeedback={setCheckThumsDownFeedback}
                                                        createOrderRequest={msg?.messageType === "technical"}
                                                        index={index}
                                                        flow={props.flow}
                                                        item={msg?.entries}
                                                        {...props}
                                                        />
                                                    )}
                                                    </div>


                                                </div>}
                                        </div>

                                        <div className="line-divider"></div>
                                    </animated.div>
                                ))}

                            </div>
                        ) : (
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    width: "100%",
                                    justifyContent: "center",
                                    height: "100%",
                                    ...fadeInProps,
                                }}
                            ></div>
                        )}
                </animated.div>

                {showMenuButtons && (
                    <A1MenuButtons
                        data={quckActionButton}
                        addMessages={props.addMessages}
                        createOrderRequest={messages[messages.length - 1]?.messageType === "technical"}
                        msg={messages[messages.length - 1]}
                        showMaximumChat={showMaximumChat}
                        setIsShowMaximumChat={setIsShowMaximumChat}
                        loading={loading}
                        scrollToBottom={scrollToLastMessage}
                        viewMenuInfo={messages[messages.length - 1]?.viewMenuInfo}
                    />
                )}
                </>
            )}
        </>

    );

};

export default Conversation;
